import React from 'react';

import PackageDefs from '~app/pages/Pricing/lib/packages/packageDefs';
import PackageHeader from '~pricing/experiments/grow_2529_forms/components/PackageHeader';
import { PackageHeaderProps } from '~pricing/components/Summary/types';

import useDetailsPackageHeaderStyles from './useStyles';

type DetailsHeader = {
  index: string;
};

type DetailsPackageHeaderProps = PackageHeaderProps & DetailsHeader;

export default function DetailsPackageHeader({
  comparisonSkuCosts,
  discountInfo,
  skuCosts,
  packageName,
  index,
}: DetailsPackageHeaderProps): JSX.Element {
  const { Highlighted, Package } = useDetailsPackageHeaderStyles({ packageName });

  return (
    <div
      className={`${Package} ${PackageDefs[packageName]?.highlighted ? Highlighted : ''}`}
      style={{ gridArea: `package${index}` }}
    >
      <PackageHeader
        comparisonSkuCosts={comparisonSkuCosts}
        discountInfo={discountInfo}
        skuCosts={skuCosts}
        packageName={packageName}
      />
    </div>
  );
}
